import { withNaming } from '@bem-react/classname'

export const cn = withNaming({ n: 'bm-', e: '__', m: '_', v: '_' })
export const styled = (style: { readonly [key: string]: string }) => style
